import { useMediaQuery, useTheme } from '@mui/material';
import { useLightningLayerEnabled } from 'features/mapping/hooks/useLightningLayerEnabled';
import { useLayersDrawerState } from 'features/mapping/hooks/useLayersDrawerState';
import { MapLayers } from 'features/mapping/mapping.constants';
import { useMapMode } from 'hooks/useMapMode';
import { useMapLayersState } from 'state/useMapLayersState/useMapLayersState';
import { useLightningToolsState } from 'state/useLightningToolsState';
import { useAuthState } from 'state/useAuthState';

/**
 * Used by components to determine if the lightning tools card is visible and
 * not hidden by another map element like the side drawer.
 */
export const useIsLightningToolsVisible = (): boolean => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('tablet'));
  const { open: isLayersDrawerOpen } = useLayersDrawerState();

  const { showMembershipProFeatures } = useAuthState();
  const { showLightningLayer } = useLightningLayerEnabled();
  const { mapLayers } = useMapLayersState();
  const { isOpen } = useLightningToolsState();
  const { isTimelineMode } = useMapMode();

  // Hide the card when it might interfere with a side drawer. On mobile the
  // bottom sheet covers the card, so hiding isn't necessary.
  const isHiddenByDrawer = isDesktop && isLayersDrawerOpen;

  return (
    showMembershipProFeatures &&
    showLightningLayer &&
    mapLayers.includes(MapLayers.LIGHTNING) &&
    isOpen &&
    !isTimelineMode &&
    !isHiddenByDrawer
  );
};
